import React from 'react';
import styled, { css } from 'styled-components';

type ComponentProps = {
  type: keyof typeof types;
  children?: React.ReactNode;
};

const types = {
  warn: css`
    --callout-bg: var(--warn);
    --callout-text-color: var(--warnContent);
  `,
  error: css`
    --callout-bg: var(--error);
    --callout-text-color: var(--errorContent);
  `,
  info: css`
    --callout-bg: var(--info);
    --callout-text-color: var(--infoContent);
  `,
} as const;

/**
 * Props for the top level wrapper element.  This is separate from the
 * definition due to syntax highlighting issues when defining inline
 */
type WrapperProps = { children: React.ReactNode };

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  border-radius: 5px;
  margin: 8px 0;
  padding: 8px;
  background-color: var(--callout-bg);
  color: var(--callout-text-color);
  font-size: var(--medium);
  width: 100%;
  justify-content: center;
  align-items: center;
  line-height: 1.5;
  .isMobileStyle & {
    text-align: center;
  }
`;

export default function Callout({ type, children }: ComponentProps) {
  return (
    <Wrapper css={types[type]}>{children ?? 'Component Elements'}</Wrapper>
  );
}
